// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import indexDBStorage from 'redux-persist-indexeddb-storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// project import
import menu from 'store/reducers/menu';
import snackbar from 'store/reducers/snackbar';
import authReducer from 'store/auth';
import WebConfigReducer from 'store/Web-Config';
import ScoreCardFilter from 'store/ScoreCardFilter';
import ScoreCardReducer from 'store/ScoreCard';
import Dashbord from 'store/Dashbord';
import EvaluationFilter from 'store/EvaluationFilter';
import AnalyticsReducer from 'store/Analytics';
import EvaluationPlayerReducer from 'store/EvaluationPlayer';
import AnalyticsFilterReducer from 'store/AnalyticsFilter';
import EvaluationReducer from 'store/Evaluation';
import InspectFilter from 'store/InspectFilter';
import Inspect from 'store/inspect';
import InspectPlayerreducer from 'store/InspectPlayer';
import Settings from 'store/Settings';
import LiveCalls from 'store/liveCalls';
import Personal from 'store/Settings/Tabs/Personalinformaion';
import AudioData from 'store/Settings/Tabs/AudioData';
import RolesAndPermissions from 'store/RolesAndPermissions';
import Features from 'store/Settings/Tabs/features';
import Management from 'store/Settings/Tabs/management';
import sopConfig from 'store/Settings/Tabs/sopConfig';
import FeedBackReducer from 'store/FeedBack';
import settingReportingReducer from 'store/Settings/Tabs/ReportingData';
import NotificationsReducer from 'store/Notifications';
import CallFlow from 'store/Settings/Tabs/CallFlow';
import Help from 'store/Help';
import EvaluationForm from 'store/Settings/Tabs/evaluationForm';
import DashboardManage from 'store/Settings/Tabs/DahboardManage';
import FileManager from 'store/Settings/Tabs/FileManager';
import DashbordFilter from 'store/DashbordFilter';
const VERSION = 3;

const getBaseURL = () => {
  const currentLocation = window.location;
  const baseURL = `${currentLocation.hostname}`;
  return baseURL;
};

const baseURL = process.env.NODE_ENV === 'production' ? getBaseURL() : 'qualitypack';
const STORE_NAME = baseURL + '_' + VERSION;

const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_SECRET_KEY || 'dev_' + STORE_NAME,
  onError: function (error) {
    // Handle the error.
    console.error('encryptTransform', error);
  }
});

const persistConfig = {
  key: 'root',
  version: VERSION,
  storage: indexDBStorage(STORE_NAME),
  // whitelist: [
  //   'analytics',
  //   'evaluation',
  //   'scorecard',
  //   'auth',
  //   'filter',
  //   'evaluationfilter',
  //   'analyticsfilter',
  //   'analyzefilter',
  //   'user',
  //   'menu',
  //   'WebConfig',
  //   'liveCalls'
  // ],
  blacklist: ['feedback'],
  transforms: [encryptor]
};

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  snackbar,
  auth: authReducer,
  WebConfig: WebConfigReducer,
  filter: ScoreCardFilter,
  scorecard: ScoreCardReducer,
  evaluationfilter: EvaluationFilter,
  analytics: AnalyticsReducer,
  evaluationPlayer: EvaluationPlayerReducer,
  analyticsfilter: AnalyticsFilterReducer,
  evaluation: EvaluationReducer,
  analyzefilter: InspectFilter,
  inspect: Inspect,
  inspectPlayer: InspectPlayerreducer,
  settings: Settings,
  liveCalls: LiveCalls,
  Personal: Personal,
  rolesAndPermissions: RolesAndPermissions,
  features: Features,
  AudioData: AudioData,
  management: Management,
  sopConfig: sopConfig,
  dashbord: Dashbord,
  feedback: FeedBackReducer,
  settingReporting: settingReportingReducer,
  notifications: NotificationsReducer,
  callFlow: CallFlow,
  help: Help,
  evaluationFormTab: EvaluationForm,
  dashbordmanagement: DashboardManage,
  fileManager: FileManager,
  dashbordFilter: DashbordFilter
});

const root = (state, action) => {
  if (action.type === 'auth/logout') {
    localStorage.removeItem('qp-inital-load');
    state = undefined;
  }
  return reducers(state, action);
};
// export default persistReducer(persistConfig, reducers);
export default persistReducer(persistConfig, root);
